import { pdfjs } from 'react-pdf';

// https://github.com/wojtekmaj/react-pdf#support-for-text-layer
import 'react-pdf/dist/Page/TextLayer.css';

// https://github.com/wojtekmaj/react-pdf#support-for-annotations
import 'react-pdf/dist/Page/AnnotationLayer.css';


/**
 * Setup react-pdf / PDFJs worker
 * required to render PDF files.
 */
export const useReactPdf = () => {
    // https://github.com/wojtekmaj/react-pdf?tab=readme-ov-file#copy-worker-to-public-directory
    pdfjs.GlobalWorkerOptions.workerSrc = 'assets/pdfjs-dist/pdf.worker.min.mjs';

    // Alternatively, you can use a CDN version:
    // pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
};
